/**
 * @param dataUrl = 'data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD//gB...'; data chain here
 * @param filename = 'my_file'; file name here
 * @param mimeType MIME type of the file (can be 'image/jpeg', 'application/pdf', etc.)
 * @returns
 */
export const dataURLtoFile = (
  dataUrl: string,
  filename: string,
  mimeType: string,
  ext?: string,
) => {
  filename += '.' + ext;
  if (!dataUrl || !filename || !ext) {
    throw new Error('Los datos de entrada son incorrectos.');
  }
  const arr = dataUrl.split(',');
  const bstr = atob(arr[1]);
  const n = bstr.length;
  const u8arr = new Uint8Array(n);

  for (let i = 0; i < n; i++) {
    u8arr[i] = bstr.charCodeAt(i);
  }

  return new File([u8arr], filename, { type: mimeType });
};

export const toFile = async (
  input: string,
  filename: string,
  mimeType: string,
): Promise<File> => {
  // 👉 Caso 1: base64 (dataURL)
  if (input.startsWith('data:')) {
    const arr = input.split(',');
    const bstr = atob(arr[1]);
    const n = bstr.length;
    const u8arr = new Uint8Array(n);

    for (let i = 0; i < n; i++) {
      u8arr[i] = bstr.charCodeAt(i);
    }

    return new File([u8arr], filename, { type: mimeType });
  }

  // 👉 Caso 2: URL
  if (input.startsWith('http')) {
    const response = await fetch(input);
    const blob = await response.blob();

    return new File([blob], filename, { type: mimeType });
  }

  throw new Error('Formato de archivo no soportado');
};
